import "./SubscriptionPreferencesLayout.scss";

import React from "react";
import { useBemBlock } from "../../../../../common/utils/bemContext/bemContextHook";
import { ISubscriptionPreferencesLayoutProps } from "./SubscriptionPreferencesLayoutModel";
import { nullFn } from "../../../../../common/utils/fpUtils";
import { SubscriptionPreferencesHrComponent } from "../hr/SubscriptionPreferencesHrComponent";
import { UmSpDcLogoElement } from "../dynamicContent/UmSpDcLogoElement";

export function SubscriptionPreferencesLayoutComponent({
    texts,
    ContentElement,
    UserInfoElement = nullFn,
}: ISubscriptionPreferencesLayoutProps) {
    const [bl, el] = useBemBlock("SubscriptionPreferencesLayout");

    return (
        <div className={bl()}>
            <UmSpDcLogoElement className={el("header")} />

            <div className={el("dark-panel")} />

            <div className={el("title")}>{texts.title}</div>

            <div className={el("dialog-message")}>
                <div className={el("dialog-message-greeting")}>
                    {texts.greetings}
                </div>
                <div className={el("dialog-message-logIn")}>{texts.logIn}</div>
            </div>

            <div className={el("line")}>
                <SubscriptionPreferencesHrComponent />
            </div>

            <ContentElement className={el("content")} texts={texts} />

            <UserInfoElement className={el("user-info")} />

            <div className={el("footer")}>{texts.footer}</div>
        </div>
    );
}
